"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CarouselItem = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CarouselItem",
  class: "pl-c1c604z0"
});
const ButtonLink = /*#__PURE__*/(0, _react2.styled)(_merchButton.NSMerchButton)({
  name: "ButtonLink",
  class: "pl-b142xt18"
});
const PrimaryLink = /*#__PURE__*/(0, _react2.styled)(_merchButton.NSMerchButton)({
  name: "PrimaryLink",
  class: "pl-p3877u"
});
const SecondaryLink = /*#__PURE__*/(0, _react2.styled)(ButtonLink)({
  name: "SecondaryLink",
  class: "pl-su2wxit"
});
const DesktopFrame = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DesktopFrame",
  class: "pl-d1lgk91t"
});
const ImageOverlay = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageOverlay",
  class: "pl-i1yw8wqa"
});
const MobileFrame = /*#__PURE__*/(0, _react2.styled)("img")({
  name: "MobileFrame",
  class: "pl-m3kydb2"
});

/**
 * TemplateItem component.
 *
 * @param {Object} props React props
 * @param {string} props.id The component's id
 * @param {string} props._name The component's tracking name
 * @param {obj} props.mobilePreviewImage The preview image used on mobile size
 * @param {obj} props.desktopPreviewImage The preview image used on desktop size
 * @param {string} props.primaryButtonText The text of the Primary/Start button
 * @param {string} props.secondaryButtonText The text of the Secondary/Preview button
 * @param {string} props.onboardingUrl The template's onboarding link
 * @param {string} props.ariaLabelStart The aria label for the Primary/Start button
 * @param {string} props.ariaLabelPreview The aria label for the Secondary/Preview button
 * @param {func} props.modalFn The function that activates the modal when clicking the preview button
 * @returns {React.ReactElement} TemplateItem component
 * @public
 */
const TemplateItem = /*#__PURE__*/(0, _react.forwardRef)(({
  _name,
  mobilePreviewImage,
  desktopPreviewImage,
  onboardingUrl,
  ariaLabelStart = 'start',
  ariaLabelPreview = 'preview',
  primaryButtonText,
  secondaryButtonText,
  modalFn
}, ref) => {
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  return /*#__PURE__*/_react.default.createElement(CarouselItem, {
    ref: ref,
    "data-cy": "template-carousel-item"
  }, /*#__PURE__*/_react.default.createElement(ImageOverlay, null, /*#__PURE__*/_react.default.createElement("picture", {
    "data-cy": "template-item-image"
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: mobilePreviewImage.url,
    media: _patternLibraryUtils.deviceMax.mobileLg
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: desktopPreviewImage.url,
    media: _patternLibraryUtils.device.tablet
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: desktopPreviewImage.url,
    alt: desktopPreviewImage.altText,
    height: desktopPreviewImage.height,
    width: desktopPreviewImage.width,
    role: "presentation"
  })), /*#__PURE__*/_react.default.createElement(MobileFrame, {
    src: mobilePreviewImage.url,
    alt: mobilePreviewImage.altText,
    height: mobilePreviewImage.height,
    width: mobilePreviewImage.width
  }), /*#__PURE__*/_react.default.createElement(DesktopFrame, null, primaryButtonText?.length > 0 && /*#__PURE__*/_react.default.createElement(PrimaryLink, {
    text: primaryButtonText,
    href: onboardingUrl,
    ariaLabel: ariaLabelStart,
    design: width < _patternLibraryUtils.size.tabletLg ? 'primary' : 'secondary',
    width: "auto",
    _name: `${_name}_start`,
    "data-cy": "start-button"
  }), secondaryButtonText?.length > 0 && /*#__PURE__*/_react.default.createElement(SecondaryLink, {
    text: secondaryButtonText,
    ariaLabel: ariaLabelPreview,
    design: "inline",
    width: "auto",
    onClick: modalFn,
    _name: `${_name}_preview`,
    "data-cy": "preview-button"
  }))));
});
TemplateItem.displayName = 'TemplateItem';
TemplateItem.propTypes = {
  id: _propTypes.default.string,
  vertical: _propTypes.default.string,
  desktopPreviewImage: _propTypes.default.shape(_image.imgPropShape),
  desktopViewIconAriaLabel: _propTypes.default.string,
  mobilePreviewImage: _propTypes.default.shape(_image.imgPropShape),
  mobileViewIconAriaLabel: _propTypes.default.string,
  onboardingUrl: _propTypes.default.string,
  templateUrl: _propTypes.default.string,
  lid: _propTypes.default.string,
  ariaLabelStart: _propTypes.default.string,
  ariaLabelPreview: _propTypes.default.string,
  primaryButtonText: _propTypes.default.string,
  secondaryButtonText: _propTypes.default.string,
  modalFn: _propTypes.default.func,
  _name: _propTypes.default.string
};
var _default = exports.default = TemplateItem;